import { selectBookActionTypes } from './Constants';
import { change, reset } from 'redux-form';

export function getSubjectDetailsOfUser(subjectId) {
	return {
		type: selectBookActionTypes.GET_SUBJECT_DETAILS_OF_USER,
		payload: { subjectId },
	};
}

export function getSubjectDetailsOfUserSuccess(data) {
	return {
		type: selectBookActionTypes.GET_SUBJECT_DETAILS_OF_USER_SUCCESS,
		payload: { data },
	};
}

export function getSubjectDetailsOfUserError() {
	return {
		type: selectBookActionTypes.GET_SUBJECT_DETAILS_OF_USER_ERROR,
	};
}

export function getSelectBook(subjectId, queries, offset) {
	return {
		type: selectBookActionTypes.GET_SELECT_BOOK,
		payload: {
			subjectId,
			queries,
			offset,
		},
	};
}

export function getSelectBookSuccess(selectBookData) {
	return {
		type: selectBookActionTypes.GET_SELECT_BOOK_SUCCESS,
		payload: {
			selectBookData,
		},
	};
}

export function getSelectBookError() {
	return {
		type: selectBookActionTypes.GET_SELECT_BOOK_ERROR,
	};
}

export function changeFilters(data) {
	return {
		type: selectBookActionTypes.CHANGE_SELECT_BOOK_FILTERS,
		payload: { data },
	};
}

export function addSelection(data) {
	return {
		type: selectBookActionTypes.ADD_SELECTION,
		payload: {
			data,
		},
	};
}

export function addSelectionError() {
	return {
		type: selectBookActionTypes.ADD_SELECTION_ERROR,
	};
}

export function toggleSelectBookModal(state) {
	return {
		type: selectBookActionTypes.TOGGLE_SELECT_BOOK_MODAL,
		payload: {
			isSelectBookModalOpen: state,
		},
	};
}

export function setSelectBookModalInfo(selectBookModalInfo, options) {
	return {
		type: selectBookActionTypes.SET_SBM_INFO,
		payload: { selectBookModalInfo, options },
	};
}

export function getEducationTypes(countryId) {
	return {
		type: selectBookActionTypes.SBM_GET_EDUCATION_TYPES,
		payload: {
			countryId,
		},
	};
}

export function getEducationTypesSuccess(educationTypes) {
	return {
		type: selectBookActionTypes.SBM_GET_EDUCATION_TYPES_SUCCESS,
		payload: {
			educationTypes,
		},
	};
}

export function getEducationTypesError(error) {
	return {
		type: selectBookActionTypes.SBM_GET_EDUCATION_TYPES_ERROR,
		error: true,
		payload: {
			error,
		},
	};
}

export function getUserDetails() {
	return {
		type: selectBookActionTypes.SBM_GET_USER_DETAILS,
	};
}

export function getUserDetailsSuccess(userData) {
	return {
		type: selectBookActionTypes.SBM_GET_USER_DETAILS_SUCCESS,
		payload: {
			userData,
		},
	};
}

export function getUserDetailsError(error) {
	return {
		type: selectBookActionTypes.SBM_GET_USER_DETAILS_ERROR,
		error: true,
		payload: {
			error,
		},
	};
}

export function changeFormField(formName, fieldName, value) {
	return change(formName, fieldName, value);
}

export function resetForm(formName) {
	return reset(formName);
}

export function setCandidateBook(data) {
	return {
		type: selectBookActionTypes.SET_CANDIDATE_BOOK,
		payload: {
			data,
		},
	};
}

export function setCandidateBookSuccess() {
	return {
		type: selectBookActionTypes.SET_CANDIDATE_BOOK_SUCCESS,
		payload: {},
	};
}

export function setCandidateBookError() {
	return {
		type: selectBookActionTypes.SET_CANDIDATE_BOOK_ERROR,
		payload: {},
	};
}

export function cleanSelectBookState() {
	return {
		type: selectBookActionTypes.CLEAN_SELECT_BOOK_STATE,
	};
}

export function setLocation(location) {
	return {
		type: selectBookActionTypes.SET_LOCATION,
		payload: {
			location,
		},
	};
}
